import { useQuery } from '../useQuery';
import { getUnassignedTasks } from '@dispatch/shared/services';
import { TaskInclude, TasksListFilter } from '@dispatch/shared/types';
import { useCurrentUserResource } from '../users';

export const useGetUnassignedTasks = (
  filters: TasksListFilter,
  enabled = true,
  include: TaskInclude[] = []
) => {
  const { isAdjuster } = useCurrentUserResource();
  const { data, status, refetch } = useQuery(
    // Prefix invalidation of ['unassigned-tasks'] still matches both keys.
    ['unassigned-tasks', include],
    () => getUnassignedTasks(filters, include),
    {
      enabled: !isAdjuster && enabled, // if user is an adjuster we don't need to get unassignedTasks
      // add high cache time to make it so that multiple calls arent fired.
      // to force a cache update when scheduler refreshes we use refetch to force an update
      cacheTime: 120000,
    }
  );
  return {
    unassignedTasks: data,
    fetchUnassignedTasks: refetch,
    unassignedTasksStatus: status,
  };
};
